import { hotfundConstants } from '../_constants/hotfund.constants';

const initialState = {
  currentColumns: [],
  defaultColumns: [
    'averageReturn',
    'fundFlow',
    'chart',
  ],
  tableColumns: [
    {
      header: 'อันดับ',
      sortKey: 'rank',
      section: 'main',
    },
    {
      header: 'กลุ่มกองทุน',
      sortKey: 'fundCategory',
      section: 'main',
    },
    {
      header: 'ผลตอบแทนเฉลี่ย',
      sortKey: 'averageReturn',
      section: 'other',
    },
    {
      header: 'ยอดเงินเข้าออก',
      sortKey: 'fundFlow',
      section: 'other',
    },
  ],
  cnsCategoryList: [
    { 
      key: 'GMF', 
      name: 'กองทั่วไป' 
    },
    { 
      key: 'LTF', 
      name: 'LTF' 
    },
    { 
      key: 'RMF', 
      name: 'RMF' 
    },
    { 
      key: 'SSF', 
      name: 'SSF' 
    },
    { 
      key: 'SSFX', 
      name: 'SSFX' 
    },
    { 
      key: 'TESG', 
      name: 'TESG' 
    }
  ],
  viewList: [
    { 
      key: 'MIN_MAX', 
      name: '5 อันดับสูงสุดต่ำสุด' 
    },
    { 
      key: 'ALL', 
      name: 'ทุกกลุ่มกองทุน' 
    },
  ],
  queries: {
    cnsCategories: ['GMF', 'LTF', 'RMF', 'SSF', 'SSFX', 'TESG'],
    dateType: '1Y',
    sortBy: null,
    sortType: 'a',
    viewType: 'MIN_MAX',
  },
  responses: {
    isFetching: false,
    data: [],
    errorMessage: null
  }
};

const hotfundReducer = (state = initialState, action) => {
  switch (action.type) {
    case hotfundConstants.FETCH_HOTFUND_START:
      return {
        ...state,
        responses: {
          ...state.responses,
          isFetching: true
        }
      };
    case hotfundConstants.FETCH_HOTFUND_SUCCESS:
      return {
        ...state,
        responses: {
          ...state.responses,
          isFetching: false,
          data: action.payload ?? [],
          errorMessage: null
        }
      };
    case hotfundConstants.FETCH_HOTFUND_FAILURE:
      return {
        ...state,
        responses: {
          ...state.responses,
          isFetching: false,
          data: [],
          errorMessage: action.payload
        }
      };
    case hotfundConstants.UPDATE_HOTFUND_QUERIES: {
      if (!action.payload || !Object.keys(action.payload).length) {
        return state;
      }

      let updateAttribute = {};
      Object.keys(action.payload).forEach(attribute => {
        let value = action.payload[`${attribute}`];
        switch (attribute) {
          case 'sortBy': {
            updateAttribute['sortType'] = state.queries.sortBy === value && state.queries.sortType !== 'a' ? 'a' : 'd'
            updateAttribute['sortBy'] = value;
            break;
          };
          default: updateAttribute[attribute] = value; 
            break;
        };
      })

      return {
        ...state,
        queries: {
          ...state.queries,
          ...updateAttribute
        }
      }
    }
    case hotfundConstants.UPDATE_HOTFUND_TABLE_COLUMNS:
      return {
        ...state,
        currentColumns: action.payload ?? [] 
      };
    default:
      return state;
  }
};

export default hotfundReducer;
